import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-with-otp',
  templateUrl: './login-with-otp.component.html',
  styleUrls: ['./login-with-otp.component.scss'],
})
export class LoginWithOtpComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
